var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-verification__container" },
    [
      _c("account-verification-modal", {
        attrs: {
          "is-dialog-visible": _vm.isAccountVerificationModalVisible,
          "is-verification-override": false,
        },
        on: { visibilityChanged: _vm.setIsAccountVerificationModalVisible },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "heading__small-medium title" }, [
        _vm._v("\n    Account Verification Required\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message" }, [
        _vm._v(
          "\n    To see schedules for " +
            _vm._s(_vm.deviceName) +
            ", please verify this account.\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "button",
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.verifyAccount()
            },
          },
        },
        [_vm._v("\n    Verify Account\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }